import { createStyles } from '@material-ui/core';
import { vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = createStyles({
  dialogTitleText: {
    color: themeColor.modalTitle,
  },
  dialogDescriptionText: {
    marginTop: '1.30vh',
    marginBottom: '6.70vh',
    color: themeColor.infoDark,
    fontSize: vw(1.32),
    letterSpacing: '0.09vw',
    lineHeight: 'unset',
  },
});
